export const PurchaseTypes = Object.freeze({
    digital_document_basis: 'digital_document_basis',
    digital_document_review: 'digital_document_review',
    digital_document_advice: 'digital_document_advice'
});
export const Documents = Object.freeze({
    will: 'will',
    prenup: 'prenup',
    future_pow: 'future_pow',
    coop: 'coop',
    favored: 'favored',
    undivided_estate_agreement: 'undivided_estate_agreement'
});
export const applicationUrl = 'https://app.testaviva.dk';
export const paymentApiUrl = 'https://payment.testaviva.dk';
